import "./CostBadge.css"
import { CircleAlert } from "lucide-react"
import { EnergyIcon } from "./SkillIcon"

export type CostBadgeProps = {
  size: "s" | "m" | "l"
  variant: "subtle" | "fill"
  cost: number
  isRelative?: boolean
  isError?: boolean
  className?: string
}

function formatFraction(value: number) {
  const sign = value < 0 ? "-" : ""
  const absValue = Math.abs(value)
  const whole = Math.trunc(absValue)
  const remainder = absValue - whole
  if (Math.abs(remainder - 0.5) > 0.001) return `${value}`
  if (whole === 0) return `${sign}½`
  return `${sign}${whole}½`
}

export function formatCostValue(cost: number) {
  const rounded = Math.round(cost * 2) / 2
  return formatFraction(rounded)
}

export function CostBadge({
  size,
  variant,
  cost,
  isRelative = false,
  isError = false,
  className,
}: CostBadgeProps) {
  const sign =
    isRelative && cost !== 0 ? (cost > 0 ? "+" : cost < 0 ? "-" : "") : ""
  const displayValue = isRelative ? Math.abs(cost) : cost
  const classes = [
    "cost-badge",
    `cost-badge-${size}`,
    `cost-badge-${variant}`,
    isError ? "cost-badge-error" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ")
  const Icon = isError ? CircleAlert : EnergyIcon

  return (
    <span className={classes}>
      {sign && <span className="cost-badge-sign">{sign}</span>}
      <span className="cost-badge-icon">
        <Icon size="1em" strokeWidth={2.25} />
      </span>
      <span className="cost-badge-value">{formatCostValue(displayValue)}</span>
    </span>
  )
}
